module.exports = __webpack_public_path__ + "static/media/OSG.6980d9e4.pdf";